import { useStoreLogger } from '@/logger.ts'
import {
  OrderDetailGet,
  OrderDetailGetListByCustomer,
  LiveOrderDetailGetList,
  PaidOrderDetailGetList
} from '@/api/Order'
import type {
  IOrderGetListResponse,
  IOrderDetailGetResponse
} from '@/types/OrderTypes.ts'

export async function LiveOrderGetList(beeNumber: number): Promise<IOrderGetListResponse> {
  const logger = useStoreLogger()
  logger.debug('LiveOrderGetList')
  const event = await LiveOrderDetailGetList({
    DatabaseFilter: {
      Where: {
        OperatorType: "And",
        Operands: [
          {
            Field: "BeeNumberOriginator",
            Value: beeNumber,
            FilterType: "Equal",
          },
        ],
      },
    },
  })
  return event
}

export async function CustomerOrderGetList(): Promise<IOrderGetListResponse> {
  const logger = useStoreLogger()
  logger.debug('CustomerOrderGetList')
  const event = await OrderDetailGetListByCustomer()
  return event
}

export async function PaidOrderGetList(beeNumber: number): Promise<IOrderGetListResponse> {
  const logger = useStoreLogger()
  logger.debug('PaidOrderGetList')
  const event = await PaidOrderDetailGetList({
    DatabaseFilter: {
      Where: {
        OperatorType: "And",
        Operands: [
          {
            Field: "BeeNumberConsultant",
            Value: beeNumber,
            FilterType: "Equal",
          },
        ],
      },
    },
  })
  return event
}

export async function GetOrderDetail(aoeOrderIdToken: string): Promise<IOrderDetailGetResponse> {
  const logger = useStoreLogger()
  logger.debug('GetOrderDetail', aoeOrderIdToken)
  const event = await OrderDetailGet(aoeOrderIdToken)
  return event
}
